import { render, staticRenderFns } from "./entriesArrow.vue?vue&type=template&id=12a43d2a"
import script from "./entriesArrow.vue?vue&type=script&lang=js"
export * from "./entriesArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports